import styled from 'styled-components';
export const GreyText = styled.span`
  font-size: 14px;
  max-width: 200px;
  word-wrap: break-word;
  display: block;
  cursor: pointer;
`;
export const GreyLink = styled.a`
  color: black;
  font-size: 14px;
  max-width: 200px;
  word-wrap: break-word;
  display: block;
  cursor: pointer;
`;